// extracted by mini-css-extract-plugin
module.exports = {"modalImage":"Modal-ModalImage-module--modal-image--VC6Cp"};